export default __webpack_public_path__ + "static/media/instagram-icon-small.f49ffc79.png";